'use strict';

require('../../modules/forms/forms');

require('../core/core');
require('../../models/discounts/services');
require('../../models/camp-discount/camp-discount');
require('../../models/mountains/regions');
require('../../models/mountains/mountains');
require('../../models/mountains/peaks');
require('../../models/mountains/routes');
require('../../models/mountains/routeTypes');
require('../../models/mountains/routeComplexities');
require('../../models/ascent/ascents');
require('../../models/ascent/ascentTypes');
require('../../models/user/user');
require('../../models/club/club');
require('../../models/committee/committee');
require('../../models/camp/camp');
require('../../models/page/page');
require('../../models/news-archive/news-archive');
require('../../models/news/news');
require('../../models/document/document');
require('../../models/discipline/discipline');
require('../../models/blog/rubric');
require('../../models/blog/post');
require('../../models/user/userQualificationGroups');
require('../../models/menu/menuItem');

require('../../forms/ascentEditForm');
require('../../forms/discountServiceForm');
require('../../forms/campDiscountForm');
require('../../forms/mountainRouteForm');
require('../../forms/tokenUsersForm');

require('../../forms/pageForm');
require('../../forms/newsArchiveForm');
require('../../forms/committeeForm');

require('../../helpers/show-modal-message/show-modal-message');

require('../../redactor/redactor.js');
require('../../redactor/lang/ru.js');

angular.module('far.admin', [
	'ui.bootstrap',
	'dndLists',
	'dekky.forms',
	'far.core',
	'far.models.discounts.services',
    'far.models.campDiscount',
	'far.models.mountains.peaks',
	'far.models.mountains.regions',
	'far.models.mountains.mountains',
	'far.models.mountains.routes',
	'far.models.mountains.routeTypes',
	'far.models.mountains.routeComplexities',
	'far.models.ascents',
	'far.models.ascentTypes',
	'far.models.user',
	'far.models.club',
	'far.models.committee',
	'far.models.camp',
	'far.models.page',
    'far.models.newsArchive',
	'far.models.news',
	'far.models.document',
	'far.models.discipline',
	'far.models.userQualificationGroups',
	'far.forms.ascentEditForm',
	'far.forms.discountServiceForm',
    'far.forms.campDiscountForm',
	'far.forms.mountainRouteForm',
	'far.forms.pageForm',
    'far.forms.newsArchiveForm',
    'far.forms.committeeForm',
    'far.forms.tokenUsersForm',
	'far.helpers.showModalMessage',
    'far.models.rubric',
    'far.models.post',
	'far.models.menuitem'
]);
